import React from 'react';
import {Button, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionGatDaysInAPiFOrModalShoppingCart, actionHandelRemoveAllItemInBasketCart,
    handelArrowModalShoppingCard, handelChangeLevelPaymentModalShoppingCard, handelToggleAnimationModalShoppingCard,
    actionChangeActiveSelectTablePostSchedule, actionChangeActiveDayPostSchedule
} from "../../../../../../redux/actions/modals/modalShoppingCard";
import {handelOpenModalLoginAndRegister} from "../../../../../../redux/actions/modals/modalLoginAndRegister";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import axios from "axios";
import {BASE_URL, DELIVERIES_GET_DAY_TIMES_POST, PUBLIC_URL_SERVER} from "../../../../../../apis";
import qs from "querystring";
import {useRouteMatch} from "react-router-dom";
import {FaTrashAlt} from "react-icons/all";

const ListProductsFooter = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();
    const {statusAnimation} = useSelector(state => state.modalShoppingCard);
    const {token, activeAddress} = useSelector(state => state.user);
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));
    const {carts, apiCarts} = useSelector(state => state.shoppingCart);


    const handelToggleAnim = () => {
        dispatch(handelToggleAnimationModalShoppingCard(!statusAnimation));
    };

    const handelNextLevelShoppingCard = () => {
        if(token) {
            if (store && store.id) {
                if (carts.length > 0 && apiCarts && Object.keys(apiCarts).length > 0) {
                    handleGetTimesInApi();
                } else {
                    swal({
                        title: "سبد خرید",
                        text: 'سبد خرید شما خالی میباشد.',
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                }
            } else {
                swal({
                    title: "سبد خرید",
                    text: ' فروشگاه یافت نشد لطفا مجددا تلاش کنید.',
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "error",
                });
            }
        }
        else
            dispatch(handelOpenModalLoginAndRegister());
    };

    const handleGetTimesInApi = () => {
        let data = {address: activeAddress.addressId, store: store.id};
        for (const cart in carts) {
            data = carts[cart].optionSelect ? {
                    ...data, [`basket_products[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].w_numbers}`,
                    [`options[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].optionSelect.id}`
                }
                : {...data, [`basket_products[${carts[cart].grades[0].gradeId}]`]: `${carts[cart].w_numbers}`};
        }

        if(localStorage.getItem("editOrderMode") !== undefined && localStorage.getItem("editOrderMode") !== null) // az safheye virayeshe sefaresh oomadim
            data = {...data, order: localStorage.getItem("editOrderMode")};
            
        axios({
            method: 'post',
            url: BASE_URL + DELIVERIES_GET_DAY_TIMES_POST,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
            data: qs.stringify(data),
        }).then((response) => {
            if (response.data.status === 'ok') {
                dispatch(actionGatDaysInAPiFOrModalShoppingCart(response.data));
                dispatch(handelArrowModalShoppingCard('next'));
                setTimeout(() => {
                        dispatch(handelChangeLevelPaymentModalShoppingCard('POST_SCHEDULE', 'زمان بندی ارسال'));
                    }
                    , 400);
                setTimeout(() => {
                    handelToggleAnim();
                }, 100);

                if(response.data.selected_time !== undefined) {
                    setTimeout(() => {
                        dispatch(actionChangeActiveSelectTablePostSchedule(response.data.selected_time));
                        dispatch(actionChangeActiveDayPostSchedule(response.data.day_selected));
                    }, 400);
                }

            }
        });
    };

    const removeAllItemsShoppingCard = () => {
        const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                cancelButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });
        buttonsOkCancel.fire({
            title: "پاکسازی سبد خرید",
            text: "آیا میخواهید کالاهای موجود از سبد خود را حذف کنید؟",
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(actionHandelRemoveAllItemInBasketCart());
            }
        });
    };

    return (
        <Row className={'w-100 m-0'}>
            {(carts.length > 0 && apiCarts && apiCarts.delivery_status && apiCarts.delivery_status.show) ?
                <Col xs={12} className={'mt-1'}>
                    <div className='btn bg-color-one btn-block pr-0 pl-0' style={{fontSize: 12}}>
                        <span>
                            {apiCarts.delivery_status.price_num !== '' && apiCarts.delivery_status.price_num > 0
                                ? 'در صورتی که '
                                : null
                            }
                        </span>
                        {apiCarts.delivery_status.price_num !== '' && apiCarts.delivery_status.price_num > 0 ?
                            <span
                                className={'text-danger'}>{apiCarts.delivery_status.price_num.toLocaleString()} تومان </span>
                            : null
                        }
                        <span>
                            {
                                apiCarts.delivery_status.price_num !== '' && apiCarts.delivery_status.price_num > 0
                                    ? ' دیگر به سبد خرید اضافه کنید، ارسال شما رایگان خواهد شد.' : 'ارسال رایگان'
                            }
                        </span>
                    </div>
                </Col>
                : ''}
            <Col xs={10} className={'mt-1'}>
                <Button variant="success" className={'base-btn-green h-100'} block
                        onClick={handelNextLevelShoppingCard}>
                    <span className={'float-right cm-font-size-500'}>تایید جزییات سفارش</span>
                    <span className={'float-left cm-font-size-500'} id={'box-subset-btn-ok-shop'}>
                        <span>{apiCarts && apiCarts.total ? parseInt(apiCarts.total).toLocaleString() : 0}</span>
                        <span> تومان</span>
                    </span>
                </Button>
            </Col>
            <Col xs={2} className={'mt-1 cm-padding-right-0 '}>
                <Button variant="success" className={'base-btn-green-border'} block
                        onClick={removeAllItemsShoppingCard}>
                    <FaTrashAlt className={'cm-font-size-500'}/>
                </Button>
            </Col>
        </Row>
    );
};

export default ListProductsFooter;
